import { type RouterContext, createResource } from '@atlassian/react-resource-router';
import { PRODUCT_JSM_ORGANIZATION_MEMBERS } from './constants.tsx';

const TEN_SECONDS_IN_MILLIS = 1000 * 10;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const productsJsmOrganizationMembersResource = createResource<any>({
	type: PRODUCT_JSM_ORGANIZATION_MEMBERS,
	getKey: (routerContext: RouterContext) =>
		`OrganizationMembers-${routerContext.match.params.organizationId}-${routerContext.query.page}-${routerContext.query.query}`,
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-products-jsm-organization-members", jiraSpaEntry: "async-resource-products-jsm-organization-members" */ './services/get-data'
		),
	maxAge: TEN_SECONDS_IN_MILLIS,
});
